import { toFixedValueCurrency } from 'app/common/lib/toFixedValue'
import { SkeletonLoading } from 'app/common/templates-next/page-template'
import { useCurrencySign } from 'app/common/components-next/currency'

import styles from './BalanceInfo.scss'


type Props = {
  loading?: boolean
  balance: number
}
export const BalanceInfo = ({ loading, balance }: Props) => {
  const currency = useCurrencySign()

  return (
    <div className={styles.row}>
      <div className={styles.labelSum}>
        {'Доступная сумма компенсаций:'}
      </div>
      {loading
        ? <div className={styles.loading}>
          <SkeletonLoading rows={1} className={styles.skeleton} />
        </div>
        : <div className={styles.sumInfo}>
          {toFixedValueCurrency(balance, false, currency)}
        </div>}
    </div>
  )
}
